import React from 'react';
import { Button, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCC } from '../../contexts/CCContext';
import { CCError } from './CCFeedback';
import { ccErrorCode } from '../../services/CCPublicationService';

export default function CCPublicationControls() {
  const cc = useCC(); const { t, i18n } = useTranslation('translation');
  const years = [...new Set(cc.publications.map((s) => s.year))].sort((a, b) => b - a);
  let countryName = cc.country;
  try { countryName = new Intl.DisplayNames([i18n.language], { type: 'region' }).of(cc.country); } catch (_) { /* Keep server country code. */ }
  const versions = cc.publications.filter((s) => !cc.selectionYear || s.year === cc.selectionYear);
  return <div className="ci-publication-controls">
    <div className="ci-control-row">
      <div className="ci-country"><span className="ci-label">{t('ci.country')}</span><strong>{countryName}</strong></div>
      <label className="ci-year"><span className="ci-label">{t('cc.year')}</span>
        <Select aria-label={t('cc.year')} placeholder={t('cc.selectYear')} value={cc.selectionYear}
          options={years.map((year) => ({ value: year, label: String(year) }))} onChange={cc.selectYear} />
      </label>
    </div>
    <label><span className="ci-label">{t('ci.dataVersion')}</span>
      <Select aria-label={t('ci.dataVersion')} placeholder={t('ci.dataVersion')} className="ci-wide" value={cc.snapshot?.snapshot_id}
        popupMatchSelectWidth={false} popupClassName="ci-publication-popup"
        options={versions.map((s) => ({ value: s.snapshot_id, label: s.title, title: s.title }))} onChange={cc.selectSnapshot} />
    </label>
    {cc.snapshot && <div className="ci-publication-name">{cc.snapshot.title}</div>}
    {cc.status === 'error' && <CCError error={cc.error} retry={cc.retry} />}
    {['loading', 'unavailable', 'selectionUnavailable', 'denied'].includes(cc.status) && <p className="ci-muted" role="status">{t(cc.status === 'denied' ? 'ci.denied' : `cc.${cc.status}`)}</p>}
    {cc.status === 'chooseVersion' && <p role="status">{t('ci.chooseVersionHelp')}</p>}
    {(cc.can('explore') || (!cc.permission && (ccErrorCode(cc.error) === 'ci_not_enabled' || cc.error?.response?.status === 404))) &&
      <details className="ci-alternative-data"><summary>{t('ci.otherData')}</summary><p>{t('ci.legacyHelp')}</p>
        <Button type="link" size="small" onClick={() => cc.setTransport('legacy')}>{t('ci.legacy')}</Button>
      </details>}
  </div>;
}
